import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=0964dfd8&scoped=true&lang=pug&"
import script from "./OtherSettings.vue?vue&type=script&lang=ts&"
export * from "./OtherSettings.vue?vue&type=script&lang=ts&"
import style0 from "./OtherSettings.vue?vue&type=style&index=0&id=0964dfd8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0964dfd8",
  null
  
)

export default component.exports